import {
  collection,
  query,
  orderBy,
  limit,
  startAfter,
  onSnapshot,
  where,
} from "firebase/firestore";
import { firestore } from "../../services/firebase";

const fetchFirestoreDataWithFilterCustomers = (
  collectionName,
  lastDoc,
  limitNumber,
  existingData,
  setData,
  fieldToFilter,
  valueToMatch,
  filters = null, 
  match = "createdAt",
  way = "desc"
) => {
  const dataCollection = collection(firestore, collectionName);

  let firestoreQuery = query(dataCollection, orderBy(match, way));

  // Filter by branchId
  if (fieldToFilter && valueToMatch !== undefined) {
    firestoreQuery = query(
      firestoreQuery,
      where(fieldToFilter, "==", valueToMatch)
    );
  }

  // Apply additional filters
  if (filters) {
    const { isMember, isBlocked, currentDate } = filters;

    // Handle membership filter
    if (isMember !== undefined && isBlocked === false) {
      if (isMember) {
        // Members: membershipExpiry > currentDate
        firestoreQuery = query(
          firestoreQuery,
          where("membershipExpiry", ">", currentDate)
        );
      } else {
        // Regular: membershipExpiry <= currentDate or null
        firestoreQuery = query(
          firestoreQuery,
          where("membershipExpiry", "<=", currentDate)
        );
        // Note: Customers with null membershipExpiry are handled client-side
      }
    }

    // Handle blocked filter
    if (isBlocked !== undefined) {
      firestoreQuery = query(
        firestoreQuery,
        where("isBlocked", "==", isBlocked)
      );
    } 
  }

  if (lastDoc) {
    firestoreQuery = query(firestoreQuery, startAfter(lastDoc.createdAt));
  }

  if (limitNumber) {
    firestoreQuery = query(firestoreQuery, limit(limitNumber));
  }

  return onSnapshot(firestoreQuery, (querySnapshot) => {
    const newData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Merge the new data with the existing data
    const mergedData = lastDoc ? [...existingData, ...newData] : newData;
    setData(mergedData);
  });
};

export default fetchFirestoreDataWithFilterCustomers;
